import React from "react";
import user1 from "./aaaaa.jpg";

export default function Testimonios() {
  return (
    <section class="testimonial section-padding" id="test">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="sectioner-header text-center white">
              <h3>Testimonios</h3>
              <span class="line"></span>
              <p class="white"></p>
            </div>
            <div class="section-content">
              <div class="row">
                <div class="offset-md-2 col-md-8 col-sm-12">
                  <div class="slider">
                    <div class="slider-item">
                      <div class="test-img">
                        <img
                          src={user1}
                          alt="Placeholder"
                          width="157"
                          height="157"
                        />
                      </div>
                      <div class="test-text">
                        <span class="title">
                          <span>Leidi</span> Dueño de negocio
                        </span>
                        La experiencia con los chicos de R & H en aquel entonces
                        Automatech fue muy buena y energizante, nunca habiamos
                        llegado a tantas personas en tan poco tiempo.
                      </div>
                    </div>
                    {/* <div class="slider-item">
                      <div class="test-img">
                        <img
                          src={user2}
                          alt="Placeholder"
                          width="157"
                          height="157"
                        />
                      </div>
                      <div class="test-text">
                        <span class="title">
                          <span>Steve Smith</span> App User
                        </span>
                        Euismod tincidunt ut laoreet dolore magna aliquam eratvo
                        lutpat. Ut wisi enim ad minim veniam, quis nostrud v
                      </div>
                    </div>
                    <div class="slider-item">
                      <div class="test-img">
                        <img
                          src={user3}
                          alt="Placeholder"
                          width="157"
                          height="157"
                        />
                      </div>
                      <div class="test-text">
                        <span class="title">
                          <span>Gordon Shaw</span> Blogger
                        </span>
                        Consectetuer adipiscing elit, sed diam nonummy nibh
                        euismod tincidunt ut laoreet dolore magna aliquam eratvo
                        lutpat. Ut wisi enim ad minim veniam, quis nostrud v
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
